import React from "react";
import ProfileTabs from "./components/ProfileTabs";
import ProfileHeader from "./components/ProfileHeader";

const EditMyProfile = () => {

	return (
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
            <ProfileHeader />
    
            <ProfileTabs editMode={true}/>
        </div>
    );
};

export default EditMyProfile;